import React from 'react'
import { RadioButtonProps } from './radio-button.types'
import styles from './radio-button.module.scss'
import cl from 'classnames'
import { Button, Text1 } from '@touche-lts/panel-ui/dist'

const RadioButtonComponent = (props: RadioButtonProps) => {
  const { className, style, selected, label, ...rest } = props

  return (
    <Button
      preset='icon'
      {...rest}
      className={cl(styles.container, className)}
      style={style}
    >
      <div className={cl(styles.circleBorder, { [styles.selected]: selected })}>
        <div className={cl(styles.circle, { [styles.selected]: selected })} />
      </div>
      {label && (
        <Text1 colorPreset='dark' style={{ marginLeft: 10 }}>
          {label}
        </Text1>
      )}
    </Button>
  )
}

const RadioButton = RadioButtonComponent
export { RadioButton }
